import { Button, Input, Modal, Select, Space } from "antd";
import { useState } from "react";
import { WarehouseSummary } from "../../../../models/Warehouse";
import PalletDevice, {
  PalletDeviceCreate,
} from "../../../../models/PalletDevice";
import PalletDeviceService from "../../../../services/PalletDeviceService";
import { useLanguage } from "../../../../context/LanguageContext";

interface CreateDeviceModalProps {
  onClose: () => void;
  onUpdateContent: () => void;
  isLoading: boolean;
  warehouses: WarehouseSummary[];
  warehouseIdx: number | undefined;
  onSetWarehouseIdx: (value: number | undefined) => void;
  palletDevices: PalletDevice[];
  isOpen: boolean;
  onWarehouseChange: (value: number) => void;
}
const DeviceCreateModal: React.FC<CreateDeviceModalProps> = ({
  onClose,
  onUpdateContent,
  isLoading,
  warehouses,
  warehouseIdx,
  onSetWarehouseIdx,
  palletDevices,
  isOpen,
  onWarehouseChange,
}) => {
  const { language } = useLanguage();

  const [deviceName, setDeviceName] = useState<string>("");

  const handleOk = () => {
    const isDuplicateName = palletDevices.some(
      (device) => device.name === deviceName
    );
    if (isDuplicateName) {
      Modal.error({
        title: language === "es" ? "Nombre duplicado" : "Duplicate Name",
        content: language === "es"
          ? "Ya existe un dispositivo con el mismo nombre. Elegi un nombre diferente."
          : "A device with the same name already exists. Please choose a different name.",
      });
    } else {
      const device = new PalletDeviceCreate();
      device.name = deviceName;
      device.warehouse_idx = warehouseIdx ?? 0;
      console.log(device);
      PalletDeviceService.createOne(device).then(() => {
        onClose();
        setDeviceName("");
        onSetWarehouseIdx(undefined);
        onUpdateContent();
      });
    }
  };

  const handleCancel = () => {
    onClose();
    setDeviceName("");
    onSetWarehouseIdx(undefined);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDeviceName(event.target.value);
  };

  return (
    <Modal
      title={language === "es" ? "Crear dispositivo" : "Create device"}
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="Back" onClick={handleCancel} shape="round">
          {language === "es" ? "Cancelar" : "Cancel"}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isLoading}
          onClick={handleOk}
          shape="round"
        >
          {language === "es" ? "Guardar" : "Submit"}
        </Button>,
      ]}
    >
      <Space wrap>
        <Input
          type="text"
          placeholder={language === "es" ? "Nombre del dispositivo" : "Device Name"}
          onChange={handleChange}
          name="deviceName"
          value={deviceName}
        />

        <Select
          style={{ width: 120 }}
          onChange={onWarehouseChange}
          options={warehouses.map((warehouse) => ({
            label: warehouse.name,
            value: warehouse.idx,

          }))}
          value={warehouseIdx}
          placeholder={language === "es" ? "Depósito" : "Warehouse"}
        />
      </Space>
    </Modal>
  );
};
export default DeviceCreateModal;
